/**
 * Return a json object with the error, ensuring, custom errors are accounted for
 * @returns JSON object with error message and stack trace
 */
const handleShapeError = (element) => {
  return {
    message: element.message,
    stack: element.stack,
  };
};

/**
 *
 * @param {any} body Current object to be shaped
 * @param {Number} depthLimit Depth limit of object to be shaped
 * @param {Number} currentDepth current level of main object depth
 * @returns shaped root object
 */
const recursiveShapeBody = (body, depthLimit, currentDepth) => {
  for (const prop of Object.keys(body)) {
    const isValueUndefined = typeof body[prop] === "undefined";
    const isValueError = body[prop] instanceof Error;
    const hasJsonSerializer = body[prop] && body[prop].toJSON;
    const isValueObject = typeof body[prop] === "object" && body[prop] !== null;

    // when depth is null, shape the whole object
    const continueRecursion = depthLimit === null || currentDepth < depthLimit;

    if (isValueUndefined) delete body[prop];
    else if (hasJsonSerializer) body[prop] = body[prop].toJSON(prop);
    // convert Error to json objects
    else if (isValueError) body[prop] = handleShapeError(body[prop]);
    // Check nested objects
    else if (isValueObject && continueRecursion) {
      body[prop] = recursiveShapeBody(body[prop], depthLimit, ++currentDepth);
      currentDepth--;
    }
  }
  return body;
};

/**
 * Recursively mutated the provided body to ensure it is Next.js serializer friendly
 * @param {any} body The body of the response, will get mutated
 * @param {Number} depth how many levels to shape the body
 * @returns shaped body object
 */
export const shapeServerResponse = (body, depth = null) => {
  body = recursiveShapeBody(body, depth, 1);
  return body;
};

export default shapeServerResponse;
